import { Store } from "store";
import noop from "lodash/noop";
import { hideModal, showConfirmModal } from "actions/modal";
import { getAccounts } from "actions/skedCore";
import {
  getLocalStorageHomeSelectedGroupName,
  setLocalStorageHomeSelectedGroupName,
} from "libs/storage/adapters";

/**
 * "You have unsaved changes" prompt for the group form.
 *
 * `close` runs when the user chooses to lose their changes; `stay` runs when
 * they choose to keep editing. `stay` matters for navigation blocking: a
 * `useBlocker` left in the `blocked` state silently swallows the *next*
 * navigation too, so the caller needs a hook to reset it.
 */
export const openPromptAccountGroupModal = ({
  isEditView = false,
  close = noop,
  stay = noop,
}: {
  isEditView?: boolean;
  close?: () => void;
  stay?: () => void;
}) => {
  const actionType = isEditView ? "editing" : "creating";
  Store.dispatch(
    showConfirmModal({
      title: `Cancel ${actionType} group`,
      message: `Are you sure you want to cancel ${actionType} this group? Any unsaved work will be lost.`,
      confirmType: "primary_outline",
      confirmText: `Continue ${actionType}`,
      cancelType: "alert",
      cancelText: "Cancel & lose changes",
      handleConfirm() {
        Store.dispatch(hideModal(false, "CONFIRM_MODAL"));
        stay();
      },
      handleCancel() {
        Store.dispatch(hideModal(true));
        close();
      },
    })
  );
};

// NOTE: this is a hack to refresh the accounts list when the account group changes.
// It updates the Redux-owned accounts state in "@/entities/accounts".
export const refreshAccountsList: () => Promise<void> = async () => {
  return new Promise<void>((resolve, reject) =>
    Store.dispatch(getAccounts((err: any) => (err ? reject(err) : resolve())))
  );
};

export const setHomeSelectedGroupNameIfNeeded = ({
  oldName,
  newName,
}: {
  oldName: string;
  newName: string;
}) => {
  const localStorageHomeSelectedGroupName =
    getLocalStorageHomeSelectedGroupName();

  if (oldName === localStorageHomeSelectedGroupName) {
    setLocalStorageHomeSelectedGroupName(newName);
  }
};
